import { emptySplitApi } from "./InjectionEndpoint";

const agencyApi = emptySplitApi.injectEndpoints({
    
    endpoints: (build: any) => ({
        
        getAgencies: build.query({
            query: (param?: any) => `/api/azienda${param?.isSelect ? '?ExcludeDeleted=true' : ''}`,
            providesTags: ['agency']
        }),

        getAgency: build.query({
            query: (id: string) => `/api/azienda/${id}`,
            providesTags: ['agency']
        }),

        updateAgency: build.mutation({
            query: ({id, ...rest}: {id: number, rest:any}) => ({
                url: `/api/azienda/${id}`,
                method: 'PUT',
                body: rest
            }),
            invalidatesTags: ['agency']
        }),

        addAgency: build.mutation({
            query: ({...rest}) => ({
                url: `/api/azienda`,
                method: 'POST',
                body: rest
            }),
            invalidatesTags: ['agency']
        }),

        deleteAgency: build.mutation({
            query: (id: number) => ({
                url: `/api/azienda/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['agency']
        }),

    }),
});

export const {
    useGetAgenciesQuery,
    useGetAgencyQuery,
    useUpdateAgencyMutation,
    useAddAgencyMutation,
    useDeleteAgencyMutation
} = agencyApi;